const cleanDisplayText = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
};

// Both exports intentionally share cleanDisplayText: engine payloads underscore
// player names inside free text exactly the same way as in name fields.
export const formatPlayerName = (name) => cleanDisplayText(name);

export const cleanMatchText = (text) => cleanDisplayText(text);
